import Money from 'components/ui-kit/money';
import { useApp } from 'hooks';
import * as S from './styles';

export default function CreditBalanceBanner() {
  const { user } = useApp();

  if (!(user?.creditBalance > 0)) {
    return null;
  }

  return (
    <S.Banner>
      You have
      {' '}
      <S.Amount><Money amount={user.creditBalance} /></S.Amount>
      {' '}
      credit — it will be applied to your next invoice.
    </S.Banner>
  );
}
